module.exports = __webpack_public_path__ + "img/top3.76a177c4.png";